// Schlanke Token-Haltung fürs Frontend: das Backend erzwingt Bearer-Auth (Rollen), das Frontend
// hängt den lokal gespeicherten Token an jeden Request/WS. Kein Cookie, kein Server-Session-State.
const KEY = 'blackfortflow.token';

// Event, mit dem der Client bei 401 die Login-Schicht auffordert, sich (neu) zu zeigen.
export const AUTH_REQUIRED_EVENT = 'bff-auth-required';

export function getToken(): string {
  try {
    return localStorage.getItem(KEY) ?? '';
  } catch {
    return '';
  }
}

export function setToken(token: string): void {
  try {
    localStorage.setItem(KEY, token.trim());
  } catch {
    /* localStorage in gehärteten Kontexten evtl. nicht verfügbar — dann kein Persistieren */
  }
}

export function clearToken(): void {
  try {
    localStorage.removeItem(KEY);
  } catch {
    /* s. o. */
  }
  window.dispatchEvent(new Event(AUTH_REQUIRED_EVENT));
}
